import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useLayoutTitle } from "../context/LayoutTitleContext.jsx";
import { useProfileParticipationsRows } from "../hooks/useProfileParticipationsRows.js";
import { ensureMarketplaceJwtForMaxParticipate } from "../lib/maxWebAppAuth.js";
import { ensureMarketplaceJwtForTelegramParticipate } from "../lib/telegramWebAppAuth.js";
import { isVitrineLoggedIn } from "../lib/wicoopProfileStorage";
import { fetchProfileCompletionRedirect } from "../utils/profileCompletion.js";
import { giveawayThumbUrl, participationsActive } from "../utils/profileParticipationsUi.js";
import styles from "./ProfilePage.module.css";

export default function ProfileActivePage() {
  const navigate = useNavigate();
  const { setPageTitle } = useLayoutTitle();
  const { rows, loading, error } = useProfileParticipationsRows();
  const active = participationsActive(rows);

  useEffect(() => {
    setPageTitle("Активные раздачи");
    return () => setPageTitle(null);
  }, [setPageTitle]);

  if (!isVitrineLoggedIn()) {
    return <Navigate to="/profile/login" replace />;
  }

  async function openParticipation(giveawayId) {
    const participateUrl = `/giveaway/${giveawayId}/participate`;
    await ensureMarketplaceJwtForMaxParticipate();
    await ensureMarketplaceJwtForTelegramParticipate();
    const completionRedirect = await fetchProfileCompletionRedirect(participateUrl);
    navigate(completionRedirect || participateUrl);
  }

  return (
    <div className={`${styles.page} ${styles.pageProfile}`}>
      {loading ? <p className={styles.status}>Загрузка…</p> : null}
      {error ? (
        <p className={styles.error} role="alert">
          {error}
        </p>
      ) : null}

      {!loading && !error && active.length === 0 ? (
        <p className={styles.empty}>Нет процессов, которые можно продолжить.</p>
      ) : null}

      {!loading && !error && active.length > 0 ? (
        <ul className={styles.list}>
          {active.map((r) => {
            const thumb = giveawayThumbUrl(r);
            return (
              <li key={r.giveawayId} className={styles.item}>
                <div className={styles.itemRow}>
                  {thumb ? (
                    <div className={styles.itemThumbWrap}>
                      <img src={thumb} alt="" className={styles.itemThumb} loading="lazy" />
                    </div>
                  ) : null}
                  <div className={styles.itemMain}>
                    <div className={styles.itemBody}>
                      <span className={styles.itemTitle}>{r.giveaway?.title ?? r.giveawayId}</span>
                      <span className={styles.pill}>{r.participation.status_title}</span>
                    </div>
                    <p className={styles.itemSub}>{r.participation.status_subtitle}</p>
                    <button
                      type="button"
                      className={styles.link}
                      onClick={() => void openParticipation(r.giveawayId)}
                    >
                      Продолжить
                    </button>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}
